<template>
  {{ $t("toast.failedToDownload") }}
  <span class="italic">
    {{ publicationTitle }}
  </span>
  <br />
  {{ $t("toast.couldTryAgain") }}
  <button class="font-bold underline" @click="retry">
    {{ $t("toast.retry") }}
  </button>
</template>
<script setup lang="ts">
import { useUILayers } from "@/components/UILayers";

const { close } = useUILayers();

const emits = defineEmits<{
  (e: "retry"): void;
}>();

defineProps<{
  publicationTitle: string;
}>();

function retry() {
  close();
  emits("retry");
}
</script>
